import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";
import { Seo } from "../components/Seo";
import { Header, scrollToHash } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Products } from "../components/Products";
import { FestiveCombos } from "../components/FestiveCombos";
import { Manifesto } from "../components/Manifesto";
import { Process } from "../components/Process";
import { Quality } from "../components/Quality";
import { Reviews } from "../components/Reviews";
import { ComingSoon } from "../components/ComingSoon";
import { WhereToBuy } from "../components/WhereToBuy";
import { StoryTeaser } from "../components/StoryTeaser";
import { Footer } from "../components/Footer";

export default function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data))
      .catch((e) => console.error("Failed to load products", e));
    const hash = sessionStorage.getItem("scrollToHash");
    if (hash) {
      sessionStorage.removeItem("scrollToHash");
      setTimeout(() => scrollToHash(hash), 600);
    }
  }, []);

  return (
    <main data-testid="home-page">
      <Seo title={"PhudG | Cold-Pressed Cooking Oils for Indian Kitchens"} description={"Explore PhudG cold-pressed mustard, groundnut and sunflower oils, made for authentic Indian cooking with traditional extraction methods."} image="/images/hero-table.jpg" path="/" />
      <Header />
      <Hero />
      <Marquee />
      <Products products={products} />
      <FestiveCombos products={products} />
      <ComingSoon products={products} />
      <Manifesto />
      <Process compact />
      <Quality />
      <Reviews />
      <WhereToBuy />
      <StoryTeaser />
      <Footer />
    </main>
  );
}
